// src/redux/products/slice.ts

import { createSlice } from '@reduxjs/toolkit';
import { fetchProductItem } from './thunk';
import { ProductItemResponse } from './types';

interface ProductItemState {
  data: ProductItemResponse | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
}

const initialState: ProductItemState = {
  data: null,
  status: 'idle',
  error: null,
};

const productItemSlice = createSlice({
  name: 'productItem',
  initialState,
  reducers: {
    resetProductItem: (state) => {
      state.data = null;
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductItem.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchProductItem.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(fetchProductItem.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Error fetching product item';
      });
  },
});

export const { resetProductItem } = productItemSlice.actions;
export default productItemSlice.reducer;
